import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { CategoriaCreateComponent } from '../categoria-create/categoria-create.component';
import { CategoriaUpdateComponent } from '../categoria-update/categoria-update.component';
import { CategoriaViewComponent } from '../categoria-view/categoria-view.component';
import { CategoriaService } from '../categoria.service';

@Component({
  selector: 'app-categoria-index',
  templateUrl: './categoria-index.component.html',
  styleUrls: ['./categoria-index.component.scss']
})
export class CategoriaIndexComponent implements OnInit {

  constructor(
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    public service: CategoriaService,
    public sesion: SesionService
  ) { }
  columnas: any[] = [
    {
      label: "Nombre",
      width: 1,
      attribute: "nombre",
      responsive: ['XS', 'SM', 'MD']
    },
    {
      label: "Descripción",
      width: 2,
      responsive: ['XS', 'SM', 'MD'],
      attribute: "descripcion"
    },
    {
      label: "Estado",
      attribute: "estado",
      width: 1,
      responsive: ['SM', 'MD'],
      styled: true,
      value: (element: any) => {
        if (element.estado == 1) {
          return '<h5><span class="badge bg-primary">Activo</span></h5>';
        } else {
          return '<h5><span class="badge bg-secondary">Inactivo</span></h5>';
        }
      }
    },
    {
      label: "Categoría Padre",
      attribute: "categoria",
      width: 1,
      responsive: ['MD'],
      value: (element: any) => {
        return element.categoria_padre?.nombre
      }
    },
  ]
  acciones: any[] = [
    {
      label: 'Detalle',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element);
      }
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.update(element);
      }
    },
    {
      label: 'Eliminar',
      icon: 'trash',
      action: (element: any, index: number) => {
        this.delete(element);
      }
    }
  ];

  filtros: any[] = [
    {
      label: 'Nombre',
      op: 'substring',
      column: 'nombre'
    }, {
      label: 'Descripción',
      op: 'substring',
      column: 'descripcion'
    }
  ];

  user = JSON.parse(localStorage.getItem('usuario') as string);

  reloadEmitter: EventEmitter<string> = new EventEmitter();

  ngOnInit(): void { }

  view(element: any): void {
    this.loading.show()
    this.service.view(element.id).subscribe({
      next: (res) => {
        this.loading.hide();
        let modalRef = this.modalService.open(CategoriaViewComponent, { size: 'lg', scrollable: true });
        modalRef.componentInstance.element = res;
        modalRef.result.then((result: any) => {
          this.reloadEmitter.emit('true');
        }, (reason: any) => { });
      }, error: (err) => {
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      }
    });
  }

  update(element: any): void {
    this.loading.show()
    this.service.view(element.id).subscribe({
      next: (res) => {
        this.loading.hide();
        let modalRef = this.modalService.open(CategoriaUpdateComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
        modalRef.componentInstance.element = res;
        modalRef.result.then((result: any) => {
          this.reloadEmitter.emit('true');
        }, (reason: any) => { });
      }, error: (err) => {
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      }
    });
  }

  delete(element: any): void {
    let modalRef = this.modalService.open(ModalDeleteComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Categoría';
    modalRef.componentInstance.texto = `¿Está seguro de que desea eliminar la categoría "${element.nombre}"?`;
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result: any) => {
      this.loading.show()
      this.service.delete(element.id).subscribe({
        next: (res) => {
          this.loading.hide();
          this.reloadEmitter.emit('true');
          this.alerts.addAlert('La categoría se eliminó con éxito.', 'success');
        },
        error: err => {
          this.loading.hide();
          if (err.error) this.formatter.showErrorAlerts(err.error);
        }
      });
    }, (reason: any) => { });
  }

  agregar(): void {
    this.modalService.open(CategoriaCreateComponent, { size: 'lg', scrollable: true, backdrop: 'static' }).result.then((result: any) => {
      this.reloadEmitter.emit('true');
    }, (reason: any) => { });
  }
}
